import { useEffect } from 'react';

/**
 * Bloquea el scroll del fondo (body/html) mientras `active` es true, para que al
 * desplazarse dentro de un modal / bottom-sheet NO se mueva la página de atrás.
 * El contenido interno del sheet (con su propio overflow) sigue scrolleando.
 */
export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    const body = document.body;
    const html = document.documentElement;
    const prevBody = body.style.overflow;
    const prevHtml = html.style.overflow;
    body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
    return () => {
      body.style.overflow = prevBody;
      html.style.overflow = prevHtml;
    };
  }, [active]);
}
